import { action, observable, runInAction } from 'mobx';
import { IAccountsDomain } from 'services/accounts/types';
import { EmailVerificationService, ResendResult } from 'services/accounts/email_verification_service';
import { LogoutResult, SessionService } from 'services/accounts/session_service';
import { ResultKind } from 'services/base/types';
import EmailVerificationMessages from './email_verification_messages';
import { BusyStore } from 'ui/base/button';

export class EmailVerificationStore {
  @observable.ref
  errorMessage: string | undefined;

  @observable.ref
  busyProceed: BusyStore;

  @observable.ref
  busyResend: BusyStore;

  @observable.ref
  busyLogout: BusyStore;

  constructor() {
    this.busyProceed = new BusyStore();
    this.busyResend = new BusyStore();
    this.busyLogout = new BusyStore();
  }

  @action.bound
  async handleProceed(domain: IAccountsDomain): Promise<ResultKind> {
    const result = await SessionService.fetch(domain);
    return runInAction(() => {
      if (result.kind === ResultKind.OK) {
        if (domain.user?.emailVerifiedAt != null) {
          return ResultKind.OK;
        } else {
          this.errorMessage = EmailVerificationMessages.emailNotVerifiedError();
          return ResultKind.USER_ERROR;
        }
      }
      return result.kind;
    });
  }

  @action.bound
  async handleResend(): Promise<ResendResult> {
    // this.resendError = undefined;
    const result = await EmailVerificationService.resend();
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        // We only care about showing the resend throttle error
        this.errorMessage = result.resendThrottleError;
      }
      return result;
    });
  }

  @action.bound
  async handleLogout(domain: IAccountsDomain): Promise<LogoutResult> {
    const result = await SessionService.logout(domain);
    return result;
  }
}
